import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import useLocationAutocompleteOptions from '../../../../../api/useLocationAutocompleteOptions';
import { useRefineSearchFiltersFormContext } from '../../useRefineSearchFiltersForm';
import ClearAllButton from '../ClearAllButton';
import { FilterMenuButton, FilterMenuButtonOption } from '../FilterMenuButton';
import FiltersField from '../FiltersField';
import LocationAutocompleteChips, { LocationAutocompleteOptions } from './LocationAutocompleteChips';
import UIStrings from '@/Utils/UIStrings';

export const locationRadiusOptions = [1, 15, 25, 50, 75, 100];

export const LocationAutocompleteField = () => {
    const form = useRefineSearchFiltersFormContext();
    const { trigger } = useLocationAutocompleteOptions();
    const locationRadius = useWatch({ control: form.control, name: 'locationRadius' });

    const locationRadiusMenuOptions: FilterMenuButtonOption<number>[] = useMemo(
        () =>
            locationRadiusOptions.map((value) => ({
                value,
                label: UIStrings.WithinNumberOfMiles(value),
            })),
        [],
    );

    const getLocationAutocompleteOptions = async (search: string): Promise<LocationAutocompleteOptions> => {
        const response = await trigger(search);

        const cities = response.cities.map((option: string) => ({ id: option, label: option }));
        const regions = response.regions.map((option: string) => ({ id: option, label: option }));
        const countries = response.countries.map((option: string) => ({ id: option, label: option }));

        return { cities, regions, countries };
    };

    return (
        <FiltersField>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <span className="text-foreground text-sm font-medium">{UIStrings.Locations}</span>
                    <FilterMenuButton
                        options={locationRadiusMenuOptions}
                        selectedValue={locationRadius}
                        onSelect={(value) => form.setValue('locationRadius', value, { shouldDirty: true })}
                        disabled={form.formState.disabled}
                    />
                </div>
                <ClearAllButton onClearAll={() => form.setValue('locations', [], { shouldDirty: true })} />
            </div>
            <LocationAutocompleteChips getAutocompleteOptions={getLocationAutocompleteOptions} />
        </FiltersField>
    );
};
